import axios from 'axios'

// 初始化DeepPay在线支付
const initOnlinePayment = form =>
  axios.post('/api/v1/pay/init-online-pay', form).then(res => res.data)

export { initOnlinePayment }
